export default [
    ['NORMAL', '正常'],
    ['DAMAGED', '损坏'],
    ['REPAIR', '修理'],
    ['MAINTAIN', '保养'],
    ['UNKNOWN', '未知'],
]
